<template>
  <v-card class="px-6 pt-2 pb-6" elevation="3" rounded="lg">
    <div v-if="subtitle" class="mb-10">
      <h3 class="text-lg font-semibold mb-0 leading-tight">{{ title }}</h3>
      <p class="text-sm text-medium-emphasis m-0">{{ subtitle }}</p>
    </div>
    <h3 v-else class="text-lg font-semibold mb-10">{{ title }}</h3>
    <slot />
  </v-card>
</template>

<script lang="ts" setup>
defineProps<{ title: string; subtitle?: string }>();
</script>
